import React from 'react'
import '../App.css'
import { useEffect, useState } from 'react';
import Typed from 'typed.js';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';


export default function Home() {

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Your EmailJS service ID, template ID, and Public Key
    const serviceId = 'service_yv59y4d';
    const templateId = 'template_dp8jccc';
    const publicKey = 'v7P5JtkcppHi21_KY';

    // Create an object with EmailJS service ID, template ID, Public Key, and Template params
    const data = {
      service_id: serviceId,
      template_id: templateId,
      user_id: publicKey,
      template_params: {
        from_name: name,
        from_email: email,
        to_name: 'Migara Thiyunuwan',
        message: message,
      }
    };

    // Send the email using EmailJS
    try {
      const res = await axios.post("https://api.emailjs.com/api/v1.0/email/send", data);
      console.log(res.data);
      setName('');
      setEmail('');
      setMessage('');
      setShowSuccessMessage(true);
    } catch (error) {
      console.error(error);
    }
  }






      useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

    useEffect(() => {
        const typedElement = document.querySelector('.typed');
        if (typedElement) {
          const typedStrings = typedElement.getAttribute('data-typed-items').split(',');
    
          const typedInstance = new Typed('.typed', {
            strings: typedStrings,
            loop: true,
            typeSpeed: 100,
            backSpeed: 50,
            backDelay: 2000
          });
    
          // Cleanup the Typed instance on component unmount
          return () => {
            typedInstance.destroy();
          };
        }
      }, []);

  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Hide sidebar on route change
    setSidebarVisible(false);
  }, [location]);

  const handleToggle = () => {
    setSidebarVisible(!isSidebarVisible);
    document.body.classList.toggle('mobile-nav-active');
  };

  useEffect(() => {
    if (isSidebarVisible) {
      document.body.classList.add('mobile-nav-active');
    } else {
      document.body.classList.remove('mobile-nav-active');
    }
  }, [isSidebarVisible]);

  return (
    <div>
      
  {/* <i className="bi bi-list mobile-nav-toggle d-xl-none"></i> */}

  
  <header id="header">
    <div className="d-flex flex-column">

      <div className="profile">
        <img src="assets/img/propic.jpg" alt="" className="img-fluid rounded-circle"/>
        <h1 className="text-light"><a href="/">Migara Thiyunuwan</a></h1>
        <h2 className="text-center text-light mt-3">Software Engineer Intern @ IFS</h2>
        <div class="social-links mt-3 text-center">
          <a href="https://web.facebook.com/migara.thiyunuwan.1/" class="facebook"><i class="bx bxl-facebook"></i></a>
          <a href="https://www.youtube.com/@Migara_Thiyunuwan" class="instagram"><i class="bx bxl-youtube"></i></a>
          <a href="https://github.com/MigaraThiyunuwan" class="google-plus"><i class="bx bxl-github"></i></a>
          <a href="https://www.instagram.com/______king_migara______?igsh=MTB5N3N0emEwdzV2aw==" class="twitter"><i class="bx bxl-instagram"></i></a>
          <a href="https://www.linkedin.com/in/migara-thiyunuwan/" class="linkedin"><i class="bx bxl-linkedin"></i></a>
        </div>
      </div>

      <button className="mobile-nav-toggle" onClick={handleToggle}>
        
        <img  src="assets/img/toggle.png" className="img-fluid" alt=""/>
       
      </button>
      <nav id="navbar" className={`nav-menu navbar ${isSidebarVisible ? 'show' : ''}`}>
        <ul>
          <li className="nav-link scrollto active"><Link to="/" onClick={handleToggle}><i className="bx bx-home"></i> <span>Home</span></Link></li>
          <li><Link to="/about" onClick={handleToggle}><i className="bx bx-user"></i> <span>About</span></Link></li>
          <li><Link to="/resume" onClick={handleToggle}><i className="bx bx-file-blank"></i> <span>Resume</span></Link></li>
          <li><Link to="/myprojects" onClick={handleToggle}><i className="bx bx-book-content"></i> <span>Projects</span></Link></li>
          <li><Link to="/gallery" onClick={handleToggle}><i className="bx bx-image"></i> <span>Gallery</span></Link></li>
          <li><Link to="/achievements" onClick={handleToggle}><i className="bx bx-star"></i> <span>Achievements</span></Link></li>
          <li><Link to="/contact" onClick={handleToggle}><i className="bx bx-phone"></i> <span>Contact</span></Link></li>
        </ul>
      </nav>
    </div>
  </header>

  
  
  <section id="hero" className="d-flex flex-column justify-content-center align-items-center">
      <div className="hero-container" data-aos="fade-in">
      <div className='downloadcv'>
        <h1 style={{fontWeight:900, fontFamily:'-moz-initial'}}>Migara Thiyunuwan</h1>
        </div>
        <div className='downloadcv'>
        <p style={{fontWeight:'bold', fontFamily:'initial'}}>
          I'm a{' '}
          <span 
            className="typed"
            data-typed-items="Undergraduate, Developer, Gamer, Traveller, Mobile Photographer,"
          ></span>
        </p>
        </div>
        <div className='downloadcv'>
          <a href="assets/cv/Migara_Thiyunuwan.pdf" target="_blank">
          <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4  rounded">
          Download CV <i style={{marginLeft:10}} class="fa-solid fa-arrow-right"></i>
          </button>
          </a>

          {/* <a href="/vesak-subapathum">
          <button class="bg-yellow-500 ml-6 hover:bg-yellow-700 text-white font-bold py-2 px-4  rounded">
          Create Vesak Card<i style={{marginLeft:30}} class="fa-solid fa-arrow-right"></i>
          </button>
          </a> */}


        </div>
      </div>
    </section>

  <main id="main">

  <section id="about" className="about">
      <div className="container">
        <div className="section-title">
          <h2>Who I am?</h2> 
          
        </div>

        <div className="row">
          <div className="col-lg-4" data-aos="fade-right">
            <img src="assets/img/propic.jpg" className="img-fluid" alt=""/>
          </div>
          <div className="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
            <h3>Software Engineer Intern @ IFS</h3>
            
            
            <p style={{ marginTop: '10px', textAlign: 'justify' }}>
                
            A Software Engineer Intern at IFS and an undergraduate student currently pursuing a BSc in Computer Science and Technology at Uva Wellassa University of Sri Lanka. My educational journey began at Bandaranayake Central College, Veyangoda.<br/><br/>

            I’m passionate about full-stack development, especially creating applications that are both visually engaging and technically sound. I enjoy building clean, 
            efficient user interfaces and solving complex backend challenges. This passion was sparked through hands-on experiences—like designing polished input screens 
            and writing structural code—that deepened my love for problem-solving and elegant code architecture.<br/><br/>

            Beyond academics and work, I stay curious and engaged by exploring new technologies, contributing to open-source projects, and participating in hackathons. 
            I also find balance through hobbies like gaming, traveling, and mobile photography. These activities sharpen both my technical creativity and personal perspective. 
            Over time, I’ve developed key soft skills in teamwork, leadership, time management, and critical thinking—traits that continue to shape my journey in tech.<br/><br/>



           
            </p>
            <div style={{display:'flex', justifyContent:'center'}}>
            <Link to="about">
            <button style={{ marginTop: '20px' }} class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded">
            More About Me <i style={{marginLeft:10}} class="fa-solid fa-arrow-right"></i>
            </button>
            </Link>
            </div>
          </div>
        </div>

      </div>
    </section>

    
    <section id="resume" className="section-bg resume"> 
      <div className="container">

        <div className="section-title">
          <h2>Resume</h2>
          <p style={{ textAlign: 'justify' }}>
          As an undergraduate student passionate about technology, I am enthusiastic about diving into the world of 
          full-stack development. Proficient in PHP, java, laravel, react and spring. I am eager to expand my skills and contribute to innovative projects. 
          Seeking opportunities to gain hands-on experience and grow as a full-stack developer.</p>
        </div>

        <div className="row">
          <div className="col-lg-6" data-aos="fade-up">
            <h3 className="resume-title">Sumary</h3>
            <div className="resume-item pb-0">
              <h4>Migara Thiyunuwan</h4>
              <p style={{ textAlign: 'justify' }}><em>Enthusiastic undergraduate student deeply interested in full-stack development. Eager to embark on a journey in crafting innovative digital solutions. 
                 I am keen to expand my knowledge and contribute to dynamic projects in the realm of full-stack development.</em></p>
              
            </div>

            <h3 className="resume-title">Education</h3>
            <div className="resume-item">
              <h4>uva wellassa university of sri lanka </h4>
              <h5>2021 - present</h5>
              <p><em>Bsc in Computer Science and Technology</em></p>
              
            </div>
            <div className="resume-item">
              <h4>AQUINAS COLLAGE OF HIGHER STUDIES</h4>
              <h5>2019 - 2020</h5>
              <p><em>Diploma in English Language and Literature (Not Completed)</em></p>
              
            </div>
            <div className="resume-item">
              <h4>Bandaranayake Central Collage - veyangoda</h4>
              <h5>2010 - 2018</h5>
              <p><em>GCE (A/L) Examination - 2018</em></p>
              <p><em>GCE (O/L) Examination - 2015</em></p>
              
            </div>
            <div className="resume-item">
              <h4>sri pangnathissa kanishta vidyalaya</h4>
              <h5>2004 - 2009</h5>
              <p><em>Grade 5 Scholarship Examination - 2009</em></p>
              
            </div>
          </div>
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <h3 className="resume-title">University Projects</h3>
            <div className="resume-item">
              <h4>web application for a jewellery shop</h4>
              <h5>April 2024 - Present</h5>
              <p><em>3rd Year Main Project </em></p>
              
            </div>
            <div className="resume-item">
              <h4>Blisshub </h4>
              <h5>Aug 2023 - Dec 2023</h5>
              <p><em>A website for a plan wedding function</em></p>
            </div>
            <div className="resume-item">
              <h4>GARDEN GURU </h4>
              <h5>Aug 2023 - Dec 2023</h5>
              <p><em>A website for Encourage Gardening</em></p>
            </div>
            <div className="resume-item">
              <h4>Trend Hire </h4>
              <h5>Aug 2023 - Dec 2023</h5>
              <p><em>Online Job Application Portal (JAVA)</em></p>
            </div>
            <div className="resume-item">
              <h4>Hire Spot </h4>
              <h5>Aug 2023 - Dec 2023</h5>
              <p><em>Online Job Application Portal (PHP)</em></p>
            </div>
            <div className="resume-item">
              <h4>Visit Sri Lanka </h4>
              <h5>Jan 2022 - April 2022</h5>
              <p><em>A static website for promote tourism</em></p>
            </div>
          </div>
          <div style={{display:'flex', justifyContent:'center'}}>
          <Link to="/resume">
            <button style={{ marginTop: '40px' }} class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded">
            View Full Resume <i style={{marginLeft:10}} class="fa-solid fa-arrow-right"></i>
            </button>
            </Link>
            </div>
        </div>

      </div>
    </section>

    <section id="skills" className="skills section-bg">
      <div className="container">
        
      <div className="section-title">
          <h2>Projects</h2>
          <p style={{ textAlign: 'justify' }}>Here, you’ll find a collection of my work in full-stack development,
             showcasing my skills and creativity. Each project represents a unique 
             challenge and opportunity to innovate, from concept to completion. I am 
             passionate about building functional, user-centric applications and continually 
             expanding my expertise. Explore my projects to see how I bring ideas to life through code and design.</p>
        </div>



      <div className='homeprojects'>

      <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}} class="max-w-sm m-2 rounded overflow-hidden shadow-lg">
        <div >
           <img class="w-full" src="assets/img/projects/gardenguru.png" alt="Sunset in the mountains"/>
          <div class="px-6 py-4">
            <div class="font-bold text-xl mb-2">GardenGuru</div>
            <p style={{textAlign: 'justify'}} class="text-gray-700 text-base">
            GardenGURU, your personal gardening assistant developed as a second-year university project at Uva Wellassa University of Sri Lanka.
           
            </p>
          </div>
        </div>
        {/* <div class="px-6 pt-4 pb-2">
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#photography</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#travel</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#winter</span>
        </div> */}
        <div style={{display:'flex', justifyContent:'center',marginBottom:20}} >
                      <a href='https://youtu.be/9VovBPv2RVs' target='__blank'>
                        <button class="bg-red-500 px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 100 100">
                            <path fill="#e85654" d="M87.574,32.465c-0.77-4.477-4.399-7.902-8.922-8.325C71.569,23.479,62.224,23,50,23	s-21.569,0.479-28.651,1.141c-4.523,0.422-8.153,3.848-8.922,8.325C11.59,37.333,11,43.181,11,50s0.59,12.667,1.426,17.535	c0.77,4.477,4.399,7.902,8.922,8.325C28.431,76.521,37.776,77,50,77s21.569-0.479,28.651-1.141c4.523-0.422,8.153-3.848,8.922-8.325	C88.41,62.667,89,56.819,89,50S88.41,37.333,87.574,32.465z"></path><path fill="#fefdef" d="M42.5,61.5l20-11.5l-20-11.5V61.5z"></path><path fill="#1f212b" d="M50,78c-10.941,0-20.612-0.385-28.745-1.145c-4.931-0.46-8.967-4.223-9.814-9.15	C10.485,62.141,10,56.184,10,50s0.485-12.141,1.441-17.705c0.847-4.927,4.883-8.69,9.815-9.15C29.388,22.385,39.059,22,50,22	s20.612,0.385,28.745,1.145c4.931,0.46,8.967,4.224,9.814,9.15l0,0C89.515,37.856,90,43.813,90,50s-0.485,12.144-1.441,17.705	c-0.847,4.927-4.883,8.69-9.815,9.15C70.612,77.615,60.941,78,50,78z M50,24c-10.879,0-20.488,0.382-28.559,1.136	c-4.033,0.377-7.335,3.46-8.03,7.498C12.475,38.086,12,43.929,12,50s0.475,11.914,1.412,17.366c0.695,4.038,3.997,7.121,8.03,7.498	C29.512,75.618,39.121,76,50,76s20.488-0.382,28.559-1.136c4.034-0.377,7.335-3.46,8.03-7.498C87.525,61.917,88,56.074,88,50	s-0.475-11.917-1.412-17.366l0,0c-0.694-4.038-3.996-7.121-8.03-7.498C70.488,24.382,60.879,24,50,24z"></path><path fill="#1f212b" d="M42.5,62c-0.086,0-0.173-0.022-0.25-0.067C42.095,61.843,42,61.679,42,61.5v-23	c0-0.179,0.095-0.343,0.25-0.433c0.155-0.089,0.345-0.09,0.5-0.001l20,11.5C62.904,49.656,63,49.821,63,50s-0.096,0.344-0.251,0.434	l-20,11.5C42.672,61.978,42.586,62,42.5,62z M43,39.364v21.271L61.497,50L43,39.364z"></path><path fill="#1f212b" d="M22.5,29.058c-0.256,0-0.474-0.195-0.498-0.456c-0.024-0.275,0.178-0.518,0.454-0.542	C30.307,27.356,39.574,27,50,27c5.443,0,10.665,0.101,15.521,0.301c0.276,0.011,0.49,0.244,0.479,0.52	c-0.011,0.275-0.261,0.496-0.52,0.479C60.638,28.101,55.43,28,50,28c-10.396,0-19.634,0.355-27.456,1.056	C22.529,29.058,22.514,29.058,22.5,29.058z"></path><path fill="#1f212b" d="M77.5,29.058c-0.015,0-0.03,0-0.045-0.002l-0.997-0.082c-0.275-0.023-0.479-0.265-0.456-0.54	c0.023-0.275,0.271-0.483,0.54-0.456l1.003,0.082c0.275,0.025,0.478,0.268,0.453,0.543C77.975,28.863,77.756,29.058,77.5,29.058z"></path><path fill="#1f212b" d="M73.5,28.743c-0.012,0-0.024,0-0.036-0.001c-1.614-0.114-3.272-0.218-4.99-0.305	c-0.276-0.014-0.488-0.249-0.474-0.525c0.014-0.276,0.247-0.493,0.525-0.474c1.725,0.088,3.39,0.192,5.01,0.307	c0.276,0.02,0.483,0.258,0.463,0.534C73.98,28.542,73.761,28.743,73.5,28.743z"></path>
                            </svg>
                            <span>Demo Video</span>
                        </button>
                    </a>
        </div>
      </div>

      <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}  class="max-w-sm m-2 rounded overflow-hidden shadow-lg">
       <div>
        <img class="w-full" src="assets/img/projects/hirespot.png" alt="Sunset in the mountains"/>
        <div class="px-6 py-4">
          <div class="font-bold text-xl mb-2">HireSpot</div>
          <p style={{textAlign: 'justify'}} class="text-gray-700 text-base">
          The Job Application Portal (PHP) is a cutting-edge web application developed for a 2nd-year Web Application Development project.
          </p>
        </div>
        </div>
        <div class="px-6 pt-4 pb-2">
          {/* <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#photography</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#travel</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#winter</span> */}
          <div style={{display:'flex', justifyContent:'center', marginBottom:20}}>
                      <a href='https://youtu.be/ZmFw3q8qPPQ' target='__blank'>
                        <button class="bg-red-500 px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 100 100">
                            <path fill="#e85654" d="M87.574,32.465c-0.77-4.477-4.399-7.902-8.922-8.325C71.569,23.479,62.224,23,50,23	s-21.569,0.479-28.651,1.141c-4.523,0.422-8.153,3.848-8.922,8.325C11.59,37.333,11,43.181,11,50s0.59,12.667,1.426,17.535	c0.77,4.477,4.399,7.902,8.922,8.325C28.431,76.521,37.776,77,50,77s21.569-0.479,28.651-1.141c4.523-0.422,8.153-3.848,8.922-8.325	C88.41,62.667,89,56.819,89,50S88.41,37.333,87.574,32.465z"></path><path fill="#fefdef" d="M42.5,61.5l20-11.5l-20-11.5V61.5z"></path><path fill="#1f212b" d="M50,78c-10.941,0-20.612-0.385-28.745-1.145c-4.931-0.46-8.967-4.223-9.814-9.15	C10.485,62.141,10,56.184,10,50s0.485-12.141,1.441-17.705c0.847-4.927,4.883-8.69,9.815-9.15C29.388,22.385,39.059,22,50,22	s20.612,0.385,28.745,1.145c4.931,0.46,8.967,4.224,9.814,9.15l0,0C89.515,37.856,90,43.813,90,50s-0.485,12.144-1.441,17.705	c-0.847,4.927-4.883,8.69-9.815,9.15C70.612,77.615,60.941,78,50,78z M50,24c-10.879,0-20.488,0.382-28.559,1.136	c-4.033,0.377-7.335,3.46-8.03,7.498C12.475,38.086,12,43.929,12,50s0.475,11.914,1.412,17.366c0.695,4.038,3.997,7.121,8.03,7.498	C29.512,75.618,39.121,76,50,76s20.488-0.382,28.559-1.136c4.034-0.377,7.335-3.46,8.03-7.498C87.525,61.917,88,56.074,88,50	s-0.475-11.917-1.412-17.366l0,0c-0.694-4.038-3.996-7.121-8.03-7.498C70.488,24.382,60.879,24,50,24z"></path><path fill="#1f212b" d="M42.5,62c-0.086,0-0.173-0.022-0.25-0.067C42.095,61.843,42,61.679,42,61.5v-23	c0-0.179,0.095-0.343,0.25-0.433c0.155-0.089,0.345-0.09,0.5-0.001l20,11.5C62.904,49.656,63,49.821,63,50s-0.096,0.344-0.251,0.434	l-20,11.5C42.672,61.978,42.586,62,42.5,62z M43,39.364v21.271L61.497,50L43,39.364z"></path><path fill="#1f212b" d="M22.5,29.058c-0.256,0-0.474-0.195-0.498-0.456c-0.024-0.275,0.178-0.518,0.454-0.542	C30.307,27.356,39.574,27,50,27c5.443,0,10.665,0.101,15.521,0.301c0.276,0.011,0.49,0.244,0.479,0.52	c-0.011,0.275-0.261,0.496-0.52,0.479C60.638,28.101,55.43,28,50,28c-10.396,0-19.634,0.355-27.456,1.056	C22.529,29.058,22.514,29.058,22.5,29.058z"></path><path fill="#1f212b" d="M77.5,29.058c-0.015,0-0.03,0-0.045-0.002l-0.997-0.082c-0.275-0.023-0.479-0.265-0.456-0.54	c0.023-0.275,0.271-0.483,0.54-0.456l1.003,0.082c0.275,0.025,0.478,0.268,0.453,0.543C77.975,28.863,77.756,29.058,77.5,29.058z"></path><path fill="#1f212b" d="M73.5,28.743c-0.012,0-0.024,0-0.036-0.001c-1.614-0.114-3.272-0.218-4.99-0.305	c-0.276-0.014-0.488-0.249-0.474-0.525c0.014-0.276,0.247-0.493,0.525-0.474c1.725,0.088,3.39,0.192,5.01,0.307	c0.276,0.02,0.483,0.258,0.463,0.534C73.98,28.542,73.761,28.743,73.5,28.743z"></path>
                            </svg>
                            <span>Demo Video</span>
                        </button>
                    </a>
          </div>
        
        </div>
      </div>

      <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}  class="max-w-sm m-2 rounded overflow-hidden shadow-lg">
       <div>
        <img class="w-full" src="assets/img/projects/trendhire.png" alt="Sunset in the mountains"/>
        <div class="px-6 py-4">
          <div class="font-bold text-xl mb-2">TrendHire</div>
          <p style={{textAlign: 'justify'}} class="text-gray-700 text-base">
          The Online Job Application Portal (JSP) is an innovative web-based platform developed as part of a 2nd-year Rapid Application Development course
          </p>
        </div>
        </div>
        <div class="px-6 pt-4 pb-2">
          {/* <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#photography</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#travel</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#winter</span>
         */}
          <div style={{display:'flex', justifyContent:'center', marginBottom:20}}>
                      <a href='https://youtu.be/U5DR_ob__lc' target='__blank'>
                        <button class="bg-red-500 px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 100 100">
                            <path fill="#e85654" d="M87.574,32.465c-0.77-4.477-4.399-7.902-8.922-8.325C71.569,23.479,62.224,23,50,23	s-21.569,0.479-28.651,1.141c-4.523,0.422-8.153,3.848-8.922,8.325C11.59,37.333,11,43.181,11,50s0.59,12.667,1.426,17.535	c0.77,4.477,4.399,7.902,8.922,8.325C28.431,76.521,37.776,77,50,77s21.569-0.479,28.651-1.141c4.523-0.422,8.153-3.848,8.922-8.325	C88.41,62.667,89,56.819,89,50S88.41,37.333,87.574,32.465z"></path><path fill="#fefdef" d="M42.5,61.5l20-11.5l-20-11.5V61.5z"></path><path fill="#1f212b" d="M50,78c-10.941,0-20.612-0.385-28.745-1.145c-4.931-0.46-8.967-4.223-9.814-9.15	C10.485,62.141,10,56.184,10,50s0.485-12.141,1.441-17.705c0.847-4.927,4.883-8.69,9.815-9.15C29.388,22.385,39.059,22,50,22	s20.612,0.385,28.745,1.145c4.931,0.46,8.967,4.224,9.814,9.15l0,0C89.515,37.856,90,43.813,90,50s-0.485,12.144-1.441,17.705	c-0.847,4.927-4.883,8.69-9.815,9.15C70.612,77.615,60.941,78,50,78z M50,24c-10.879,0-20.488,0.382-28.559,1.136	c-4.033,0.377-7.335,3.46-8.03,7.498C12.475,38.086,12,43.929,12,50s0.475,11.914,1.412,17.366c0.695,4.038,3.997,7.121,8.03,7.498	C29.512,75.618,39.121,76,50,76s20.488-0.382,28.559-1.136c4.034-0.377,7.335-3.46,8.03-7.498C87.525,61.917,88,56.074,88,50	s-0.475-11.917-1.412-17.366l0,0c-0.694-4.038-3.996-7.121-8.03-7.498C70.488,24.382,60.879,24,50,24z"></path><path fill="#1f212b" d="M42.5,62c-0.086,0-0.173-0.022-0.25-0.067C42.095,61.843,42,61.679,42,61.5v-23	c0-0.179,0.095-0.343,0.25-0.433c0.155-0.089,0.345-0.09,0.5-0.001l20,11.5C62.904,49.656,63,49.821,63,50s-0.096,0.344-0.251,0.434	l-20,11.5C42.672,61.978,42.586,62,42.5,62z M43,39.364v21.271L61.497,50L43,39.364z"></path><path fill="#1f212b" d="M22.5,29.058c-0.256,0-0.474-0.195-0.498-0.456c-0.024-0.275,0.178-0.518,0.454-0.542	C30.307,27.356,39.574,27,50,27c5.443,0,10.665,0.101,15.521,0.301c0.276,0.011,0.49,0.244,0.479,0.52	c-0.011,0.275-0.261,0.496-0.52,0.479C60.638,28.101,55.43,28,50,28c-10.396,0-19.634,0.355-27.456,1.056	C22.529,29.058,22.514,29.058,22.5,29.058z"></path><path fill="#1f212b" d="M77.5,29.058c-0.015,0-0.03,0-0.045-0.002l-0.997-0.082c-0.275-0.023-0.479-0.265-0.456-0.54	c0.023-0.275,0.271-0.483,0.54-0.456l1.003,0.082c0.275,0.025,0.478,0.268,0.453,0.543C77.975,28.863,77.756,29.058,77.5,29.058z"></path><path fill="#1f212b" d="M73.5,28.743c-0.012,0-0.024,0-0.036-0.001c-1.614-0.114-3.272-0.218-4.99-0.305	c-0.276-0.014-0.488-0.249-0.474-0.525c0.014-0.276,0.247-0.493,0.525-0.474c1.725,0.088,3.39,0.192,5.01,0.307	c0.276,0.02,0.483,0.258,0.463,0.534C73.98,28.542,73.761,28.743,73.5,28.743z"></path>
                            </svg>
                            <span>Demo Video</span>
                        </button>
                    </a>
          </div>
        
        </div>
      </div>

      

      <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}  class="max-w-sm m-2 rounded overflow-hidden shadow-lg">
        <div>
        <img class="w-full" src="assets/img/projects/blisshub.png" alt="Sunset in the mountains"/>
        <div class="px-6 py-4">
          <div class="font-bold text-xl mb-2">BlissHub</div>
          <p style={{textAlign: 'justify'}} class="text-gray-700 text-base">
          It's an all-inclusive Wedding Planning Website designed to bring elegance and efficiency to the wedding planning process.
          </p>
        </div>
        </div>
        <div class="px-6 pt-4 pb-2">
          {/* <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#photography</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#travel</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#winter</span> */}

        <div style={{display:'flex', justifyContent:'center', marginBottom:20}}>
                      <a href='https://youtu.be/1LFpwJ7wvoQ' target='__blank'>
                        <button class="bg-red-500 px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 100 100">
                            <path fill="#e85654" d="M87.574,32.465c-0.77-4.477-4.399-7.902-8.922-8.325C71.569,23.479,62.224,23,50,23	s-21.569,0.479-28.651,1.141c-4.523,0.422-8.153,3.848-8.922,8.325C11.59,37.333,11,43.181,11,50s0.59,12.667,1.426,17.535	c0.77,4.477,4.399,7.902,8.922,8.325C28.431,76.521,37.776,77,50,77s21.569-0.479,28.651-1.141c4.523-0.422,8.153-3.848,8.922-8.325	C88.41,62.667,89,56.819,89,50S88.41,37.333,87.574,32.465z"></path><path fill="#fefdef" d="M42.5,61.5l20-11.5l-20-11.5V61.5z"></path><path fill="#1f212b" d="M50,78c-10.941,0-20.612-0.385-28.745-1.145c-4.931-0.46-8.967-4.223-9.814-9.15	C10.485,62.141,10,56.184,10,50s0.485-12.141,1.441-17.705c0.847-4.927,4.883-8.69,9.815-9.15C29.388,22.385,39.059,22,50,22	s20.612,0.385,28.745,1.145c4.931,0.46,8.967,4.224,9.814,9.15l0,0C89.515,37.856,90,43.813,90,50s-0.485,12.144-1.441,17.705	c-0.847,4.927-4.883,8.69-9.815,9.15C70.612,77.615,60.941,78,50,78z M50,24c-10.879,0-20.488,0.382-28.559,1.136	c-4.033,0.377-7.335,3.46-8.03,7.498C12.475,38.086,12,43.929,12,50s0.475,11.914,1.412,17.366c0.695,4.038,3.997,7.121,8.03,7.498	C29.512,75.618,39.121,76,50,76s20.488-0.382,28.559-1.136c4.034-0.377,7.335-3.46,8.03-7.498C87.525,61.917,88,56.074,88,50	s-0.475-11.917-1.412-17.366l0,0c-0.694-4.038-3.996-7.121-8.03-7.498C70.488,24.382,60.879,24,50,24z"></path><path fill="#1f212b" d="M42.5,62c-0.086,0-0.173-0.022-0.25-0.067C42.095,61.843,42,61.679,42,61.5v-23	c0-0.179,0.095-0.343,0.25-0.433c0.155-0.089,0.345-0.09,0.5-0.001l20,11.5C62.904,49.656,63,49.821,63,50s-0.096,0.344-0.251,0.434	l-20,11.5C42.672,61.978,42.586,62,42.5,62z M43,39.364v21.271L61.497,50L43,39.364z"></path><path fill="#1f212b" d="M22.5,29.058c-0.256,0-0.474-0.195-0.498-0.456c-0.024-0.275,0.178-0.518,0.454-0.542	C30.307,27.356,39.574,27,50,27c5.443,0,10.665,0.101,15.521,0.301c0.276,0.011,0.49,0.244,0.479,0.52	c-0.011,0.275-0.261,0.496-0.52,0.479C60.638,28.101,55.43,28,50,28c-10.396,0-19.634,0.355-27.456,1.056	C22.529,29.058,22.514,29.058,22.5,29.058z"></path><path fill="#1f212b" d="M77.5,29.058c-0.015,0-0.03,0-0.045-0.002l-0.997-0.082c-0.275-0.023-0.479-0.265-0.456-0.54	c0.023-0.275,0.271-0.483,0.54-0.456l1.003,0.082c0.275,0.025,0.478,0.268,0.453,0.543C77.975,28.863,77.756,29.058,77.5,29.058z"></path><path fill="#1f212b" d="M73.5,28.743c-0.012,0-0.024,0-0.036-0.001c-1.614-0.114-3.272-0.218-4.99-0.305	c-0.276-0.014-0.488-0.249-0.474-0.525c0.014-0.276,0.247-0.493,0.525-0.474c1.725,0.088,3.39,0.192,5.01,0.307	c0.276,0.02,0.483,0.258,0.463,0.534C73.98,28.542,73.761,28.743,73.5,28.743z"></path>
                            </svg>
                            <span>Demo Video</span>
                        </button>
                    </a>
          </div>

          
        </div>
        
      </div>
      

      </div>
      <div style={{display:'flex', justifyContent:'center', marginTop:40}}>
                        <a href="./myprojects">
                            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4  rounded">
                                View More Projects<i style={{marginLeft:10}} class="fa-solid fa-arrow-right"></i>
                            </button>
                        </a>
         </div>
      </div>
    </section>

    <section id="facts" className="facts">
      <div className="container">

        <div className="section-title">
          <h2>Gallery</h2>
          <p style={{ textAlign: 'justify' }}>Passionate undergraduate student with a keen interest in mobile photography.
           Combining technical skills with a creative eye, I capture compelling moments through my lens. Eager to showcase 
           my unique perspective and contribute to innovative digital projects.</p>
        </div>
        <div className="tz-gallery">
                    
                   
                    <div className='mobilecarosal'>
                    <div id="carouselExample" class="carousel slide">
                      <div class="carousel-inner">
                        <div class="carousel-item active">
                          <img src="assets/img/mobilep/18.jpg" class="d-block w-100" alt="..."/>
                        </div>
                        <div class="carousel-item">
                          <img src="assets/img/travel/12.jpg" class="d-block w-100" alt="..."/>
                        </div>
                        <div class="carousel-item">
                          <img src="assets/img/travel/4.jpg" class="d-block w-100" alt="..."/>
                        </div>
                        <div class="carousel-item">
                          <img src="assets/img/mobilep/8.jpg" class="d-block w-100" alt="..."/>
                        </div>
                        <div class="carousel-item">
                          <img src="assets/img/travel/7.jpg" class="d-block w-100" alt="..."/>
                        </div>
                        <div class="carousel-item">
                          <img src="assets/img/travel/82.jpg" class="d-block w-100" alt="..."/>
                        </div>
                      </div>
                      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
                    </div>
                    </div>
                    
                    <div className='pccarosal'>
                    <div class="col-lg-12 " data-aos="fade-right">
          
                      <img src="assets/img/mobilep/pc.png" class="img-fluid" alt=""/>
                    </div>
                      {/* <div id="default-carousel" class="relative w-full" data-carousel="slide">
    
                        <div class="relative h-56 overflow-hidden rounded-lg md:h-96">
                            
                            <div class="hidden duration-700 ease-in-out" data-carousel-item>
                                <img src="assets/img/mobilep/18.jpg" class="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="..."/>
                            </div>
                            
                            <div class="hidden duration-700 ease-in-out" data-carousel-item>
                                <img src="assets/img/mobilep/12.jpg" class="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="..."/>
                            </div>
                            
                            <div class="hidden duration-700 ease-in-out" data-carousel-item>
                                <img src="assets/img/travel/4.jpg" class="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="..."/>
                            </div>
                            
                            <div class="hidden duration-700 ease-in-out" data-carousel-item>
                                <img src="assets/img/mobilep/8.jpg" class="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="..."/>
                            </div>
                          
                            <div class="hidden duration-700 ease-in-out" data-carousel-item>
                                <img src="assets/img/travel/7.jpg" class="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="..."/>
                            </div>
                        </div>
                        
                        <div class="absolute z-30 flex -translate-x-1/2 bottom-5 left-1/2 space-x-3 rtl:space-x-reverse">
                            <button type="button" class="w-3 h-3 rounded-full" aria-current="true" aria-label="Slide 1" data-carousel-slide-to="0"></button>
                            <button type="button" class="w-3 h-3 rounded-full" aria-current="false" aria-label="Slide 2" data-carousel-slide-to="1"></button>
                            <button type="button" class="w-3 h-3 rounded-full" aria-current="false" aria-label="Slide 3" data-carousel-slide-to="2"></button>
                            <button type="button" class="w-3 h-3 rounded-full" aria-current="false" aria-label="Slide 4" data-carousel-slide-to="3"></button>
                            <button type="button" class="w-3 h-3 rounded-full" aria-current="false" aria-label="Slide 5" data-carousel-slide-to="4"></button>
                        </div>
                        
                        <button type="button" class="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none" data-carousel-prev>
                            <span class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
                                <svg class="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 1 1 5l4 4"/>
                                </svg>
                                <span class="sr-only">Previous</span>
                            </span>
                        </button>
                        <button type="button" class="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none" data-carousel-next>
                            <span class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
                                <svg class="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
                                </svg>
                                <span class="sr-only">Next</span>
                            </span>
                        </button>
                      </div> */}
                    </div>
                    <div style={{display:'flex', justifyContent:'center',  marginTop:40}}>
                        <a href="./gallery">
                            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4  rounded">
                                View More Images<i style={{marginLeft:10}} class="fa-solid fa-arrow-right"></i>
                            </button>
                        </a>
                    </div>
                    
                </div>
        

      </div>
    </section>

    <section id="skills" className="skills section-bg">
      <div className="container">
        
      <div className="section-title">
          <h2>Achievements</h2>
          <p style={{ textAlign: 'justify' }}>As an undergraduate student, I've embarked on a journey fueled by curiosity, dedication, and a relentless pursuit of excellence. 
          Throughout my academic tenure, I've actively sought opportunities to challenge myself, broaden my horizons,
           and make meaningful contributions within and beyond the classroom.</p>
        </div>



      <div className='homeprojects'>

      <div class="max-w-sm m-2 rounded overflow-hidden shadow-lg">
        <img class="w-full" src="assets/img/achievements/industry_visit.jpg" alt="Sunset in the mountains"/>
        <div class="px-6 py-4">
          <div style={{textAlign: 'justify'}} class="font-bold text-xl mb-2">
          A Comprehensive Industry Visit to IFS: Exploring Innovation and Professional Growth Opportunities
          </div>
          
        </div>
        {/* <div class="px-6 pt-4 pb-2">
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#photography</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#travel</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#winter</span>
        </div> */}
        
      </div>

      <div class="max-w-sm m-2 rounded overflow-hidden shadow-lg">
        <img class="w-full" src="assets/img/achievements/ias.png" alt="Sunset in the mountains"/>
        <div class="px-6 py-4">
          <div style={{textAlign: 'justify'}} class="font-bold text-xl mb-2">
          Member of the Membership Development Standing Committee in the IEEE Industry Applications Society at Uva Wellassa University
          </div>
          
        </div>
        {/* <div class="px-6 pt-4 pb-2">
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#photography</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#travel</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#winter</span>
        </div> */}
        
      </div>

      <div class="max-w-sm m-2 rounded overflow-hidden shadow-lg">
        <img class="w-full" src="assets/img/achievements/sihinayata.png" alt="Sunset in the mountains"/>
        <div class="px-6 py-4">
          <div style={{textAlign: 'justify'}} class="font-bold text-xl mb-2">
          Volunteering for Community Empowerment - "Sihinayata Athwelak" Project
          </div>
          
        </div>
        <div class="px-6 pt-4 pb-2">
          {/* <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#photography</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#travel</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#winter</span> */}
          
        
        </div>
      </div>

      <div class="max-w-sm m-2 rounded overflow-hidden shadow-lg">
        <img style={{width:500, height:257}} class="w-full" src="assets/img/achievements/eablaze.jpeg" alt="Sunset in the mountains"/>
        <div class="px-6 py-4">
          <div style={{textAlign: 'justify'}} class="font-bold text-xl mb-2">
          Championship Triumph: Leading the 'Team Rivalz' to Victory in EAblaze Cyber Games E-Sports Competition 2020
          </div>
          
        </div>
        <div class="px-6 pt-4 pb-2">
          {/* <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#photography</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#travel</span>
          <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#winter</span>
         */}
          
        
        </div>
      </div>

      

     
      

      </div>
      <div style={{display:'flex', justifyContent:'center', marginTop:40}}>
                        <a href="./achievements">
                            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4  rounded">
                                View More Achievements<i style={{marginLeft:10}} class="fa-solid fa-arrow-right"></i>
                            </button>
                        </a>
         </div>
      </div>
    </section>
  

    
    <section id="contact" className="contact">
      <div className="container">

        <div className="section-title">
          <h2>Contact and Feedback</h2>
          <p>Whether you're here out of curiosity or seeking collaboration, 
            I'm thrilled to connect. Drop me a line using the form below, 
            and let's start a conversation. Whether it's about a project, an idea, 
            or just to say hello, I'm eager to hear from you. Let's create something amazing together!</p>

            
        </div>

        <div className="row" data-aos="fade-in">

          <div className="col-lg-5 d-flex align-items-stretch">
            <div className="info">
              <div className="address">
                <i className="bi bi-geo-alt"></i>
                <h4>Location:</h4>
                <p>58/1, Waragoda, Aththanagalla.</p>
              </div>

              <div className="email">
                <i className="bi bi-envelope"></i>
                <h4>Email:</h4>
                <p>migarathiyunuwan@gmail.com</p>
              </div>

              <div className="phone">
                <i className="bi bi-phone"></i>
                <h4>Call:</h4>
                <p>+9477 14 16 968</p>
              </div>

              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7692.870548039896!2d80.14850759784075!3d7.109258757060544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2slk!4v1717704469059!5m2!1sen!2slk" style={{ border: 0, width: '100%', height: '290px' }}   allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

              
            </div>

          </div>

          <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
            <form onSubmit={handleSubmit} action="forms/contact.php" method="post" role="form" className="php-email-form">
              <div className="row">
                <div className="form-group col-md-6">
                  <label for="name">Your Name</label>
                  <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} className="form-control" id="name" required/>
                </div>
                <div className="form-group col-md-6">
                  <label for="name">Your Email</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" name="email" id="email" required/>
                </div>
              </div>
              {/* <div className="form-group">
                <label for="name">Subject</label>
                <input type="text" className="form-control" name="subject" id="subject" required/>
              </div> */}
              <div className="form-group">
                <label for="name">Message</label>
                <textarea value={message} onChange={(e) => setMessage(e.target.value)} className="form-control" name="message" rows="10" required></textarea>
              </div>
              <div className="my-3">
                <div className="loading">Loading</div>
                <div className="error-message"></div>
                <div className="sent-message">Your message has been sent. Thank you!</div>
              </div>
              <div className="text-center"><button type="submit">Send Message</button></div>
              {showSuccessMessage && (
                    <div className='contactAlert'>
                    <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative" role="alert">
                        <strong className="font-bold">Message sent successfully!</strong>
                    </div>
                    </div>
                )}
            </form>
          </div>

        </div>

      </div>
    </section>

  </main>

 
  <footer id="footer">
    <div className="container">
      
      <div className="credits">
        
       Developed by <a href="{{ asset('/') }}">Migara Thiyunuwan</a>
      </div>
    </div>
  </footer>

  <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i
      className="bi bi-arrow-up-short"></i></a>

 
  


  
    </div>
  )
}
